/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "phone";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface DisplayUnits {
}

export enum DisplayUnits_Enum {
  IMPERIAL = 0,
  METRIC = 1,
  UNRECOGNIZED = -1,
}

export function displayUnits_EnumFromJSON(object: any): DisplayUnits_Enum {
  switch (object) {
    case 0:
    case "IMPERIAL":
      return DisplayUnits_Enum.IMPERIAL;
    case 1:
    case "METRIC":
      return DisplayUnits_Enum.METRIC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DisplayUnits_Enum.UNRECOGNIZED;
  }
}

export function displayUnits_EnumToJSON(object: DisplayUnits_Enum): string {
  switch (object) {
    case DisplayUnits_Enum.IMPERIAL:
      return "IMPERIAL";
    case DisplayUnits_Enum.METRIC:
      return "METRIC";
    case DisplayUnits_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseDisplayUnits(): DisplayUnits {
  return {};
}

export const DisplayUnits = {
  encode(_: DisplayUnits, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DisplayUnits {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDisplayUnits();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DisplayUnits {
    return {};
  },

  toJSON(_: DisplayUnits): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DisplayUnits>, I>>(base?: I): DisplayUnits {
    return DisplayUnits.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DisplayUnits>, I>>(_: I): DisplayUnits {
    const message = createBaseDisplayUnits();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
